exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-icon[data-v-60f3622b]{position:absolute;top:50%;right:20px;font-size:20px;margin-top:-12px;cursor:pointer}.close-icon.success[data-v-60f3622b]{color:#67c23a}.close-icon.error[data-v-60f3622b]{color:#f56c6c}.close-icon.warning[data-v-60f3622b]{color:#e6a23c}.close-icon.danger[data-v-60f3622b]{color:#515256}p[data-v-60f3622b]{font-size:14px;width:100%;line-height:20px;padding:14px 24px;box-sizing:border-box;padding-right:40px}p.success[data-v-60f3622b]{color:#67c23a}p.error[data-v-60f3622b]{color:#f56c6c}p.warning[data-v-60f3622b]{color:#e6a23c}p.danger[data-v-60f3622b]{color:#515256}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60f3622b","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Message/index.vue
// module id = 722
// module chunks = 0